module.exports = __webpack_public_path__ + "img/inside.ad74d637.png";